import React from 'react';
import { FormattedMessage } from 'react-intl';
import LoadingIndicator from './indicator';
var staticIndicator = /*#__PURE__*/React.createElement(LoadingIndicator, {
  global: true
}, /*#__PURE__*/React.createElement(FormattedMessage, {
  id: 'loadingIndicator.message',
  defaultMessage: 'Hang Tight...'
}));
export default staticIndicator;